export const GProductIcon = ({ width = '507px', height = '582px' }: { width?: '507px' | '250px'; height?: '582px' | '287px' }) => {
  const cls = ['bg-gray-100 text-gray-500 dark:bg-gray-800 flex justify-center items-center leading-6'];
  if (width === '507px') cls.push('w-[507px]');
  if (width === '250px') cls.push('w-[250px]');
  if (height === '582px') cls.push('h-[582px]');
  if (height === '287px') cls.push('h-[287px]');

  return <div className={cls.join(' ')}>NO IMAGE</div>;
};
